import { combineReducers } from 'redux'
import { REDUCER_NAME } from './const'
import { reducer as barcodeReducer, REDUCER_NAME as BARCODE_REDUCER_NAME } from './barcode'
import { reducer as processInstanceDetailReducer, REDUCER_NAME as PROCESS_INSTANCE_DETAIL_REDUCER_NAME } from './instance-detail'
import { reducer as stateResponsibleReducer, REDUCER_NAME as STATE_RESPONSIBLE_REDUCER_NAME } from './state-responsible'
import { reducer as taskDefinitionReducer, REDUCER_NAME as TASK_DEFINITION_REDUCER_NAME } from './task-definition'
import { reducer as taskDetailReducer, REDUCER_NAME as TASK_DETAIL_REDUCER_NAME } from './task-detail'
import { reducer as taskListReducer, REDUCER_NAME as TASK_LIST_REDUCER_NAME } from './task-list'
import { reducer as versionSummaryReducer, REDUCER_NAME as VERSION_SUMMARY_REDUCER_NAME } from './version-summary'


const reducer = combineReducers({
    [BARCODE_REDUCER_NAME]: barcodeReducer,
    [PROCESS_INSTANCE_DETAIL_REDUCER_NAME]: processInstanceDetailReducer,
    [STATE_RESPONSIBLE_REDUCER_NAME]: stateResponsibleReducer,
    [TASK_DEFINITION_REDUCER_NAME]: taskDefinitionReducer,
    [TASK_DETAIL_REDUCER_NAME]: taskDetailReducer,
    [TASK_LIST_REDUCER_NAME]: taskListReducer,
    [VERSION_SUMMARY_REDUCER_NAME]: versionSummaryReducer,
})

export {
    reducer,
    REDUCER_NAME,
}



// WEBPACK FOOTER //
// ./src/modules/process/state/index.js